<template>
  <div>
    <b-collapse
      class="card mb-50"
      animation="slide"
      v-for="(status, index) of statuses"
      :key="index"
      :open="isOpen === index"
      @open="isOpen = index"
    >
      <template #trigger="props">
        <mobile-status-header
          :status="status"
          :records="recordsByStatusId(status.id)"
          :showRyg="showRyg"
          :props="props"
        ></mobile-status-header>
      </template>

      <mobile-status-body
        :records="recordsByStatusId(status.id)"
        :show-next-contact="showNextContact"
      ></mobile-status-body>
    </b-collapse>
  </div>
</template>

<script>
import MobileStatusHeader from "./MobileStatusHeader";
import MobileStatusBody from "./MobileStatusBody";

export default {
  name: "MobileStatusSection",
  components: {MobileStatusBody, MobileStatusHeader},
  props: {
    statuses: {
      type: Array,
      required: true,
    },
    records: {
      type: Array,
      required: true,
    },
    showNextContact: {
      type: Boolean,
      default: false,
    },
    showRyg: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    recordsByStatusId(statusId) {
      return this.records.filter(record => record.current_status_id === statusId);
    }
  },
};
</script>
